import { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ArrowRight, Calendar } from "lucide-react";
import { PageHero } from "@/components/Ui";
import { NEWS_CATEGORIES } from "@/data/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const fmtDate = (d) => new Date(d).toLocaleDateString("it-IT", { day: "2-digit", month: "long", year: "numeric" });

const News = () => {
  const [news, setNews] = useState([]);
  const [cat, setCat] = useState("Tutte");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    axios.get(`${API}/news`, { params: cat === "Tutte" ? {} : { categoria: cat } })
      .then((r) => setNews(r.data))
      .finally(() => setLoading(false));
  }, [cat]);

  const renderList = () => {
    if (loading) return <p className="text-slate-500">Caricamento…</p>;
    if (news.length === 0) return <p className="text-slate-500" data-testid="news-empty">Nessun articolo per questa categoria.</p>;
    return (
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {news.map((n) => (
          <Link key={n.id} to={`/news/${n.id}`} data-testid={`news-card-${n.id}`} className="group bg-white border border-gray-100 shadow-crisp hover:shadow-crisp-lg hover:border-gold-500 transition-all duration-300 flex flex-col">
            <div className="overflow-hidden h-52">
              <img src={n.immagine} alt={n.titolo} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
            <div className="p-6 flex flex-col flex-1">
              <div className="flex items-center gap-3 text-xs">
                <span className="bg-gold-500 text-navy-900 font-bold uppercase tracking-[0.1em] px-2.5 py-1">{n.categoria}</span>
                <span className="flex items-center gap-1 text-slate-500"><Calendar className="w-3.5 h-3.5" />{fmtDate(n.data)}</span>
              </div>
              <h3 className="mt-4 font-serif text-xl font-semibold text-navy-900 leading-snug group-hover:text-gold-600 transition-colors">{n.titolo}</h3>
              <p className="mt-3 text-sm text-slate-600 leading-relaxed flex-1">{n.estratto}</p>
              <span className="mt-5 inline-flex items-center gap-2 text-sm font-bold uppercase tracking-[0.1em] text-navy-900 group-hover:text-gold-600 transition-colors">Leggi <ArrowRight className="w-4 h-4" /></span>
            </div>
          </Link>
        ))}
      </div>
    );
  };

  return (
    <div data-testid="news-page">
      <PageHero eyebrow="News e comunicati" title="Aggiornamenti dal mondo della scuola" subtitle="Ordinanze, scadenze e novità su GPS, mobilità, concorsi, CAF e Patronato, formazione e molto altro." />

      <section className="bg-white py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="flex flex-wrap gap-2 mb-12" data-testid="news-categories">
            {NEWS_CATEGORIES.map((c) => (
              <button
                key={c}
                onClick={() => setCat(c)}
                data-testid={`news-cat-${c}`}
                className={`px-4 py-2 text-xs uppercase tracking-[0.1em] font-bold border transition-colors duration-200 ${
                  cat === c ? "bg-navy-900 text-white border-navy-900" : "border-gray-200 text-navy-900 hover:border-gold-500"
                }`}
              >
                {c}
              </button>
            ))}
          </div>

          {renderList()}
        </div>
      </section>
    </div>
  );
};

export default News;
